export const passengerPage = {
    baggage: ['Багаж: ', 'Baggage: '],
    document: ['Документ: ', 'Document: '],
    female: ['жен', 'female'],
    femaleShort: ['Ж', 'F'],
    forFilteringConditions: ['для указанных условий фильтрации', 'for the specified filtering conditions'],
    male: ['муж', 'male'],
    maleShort: ['М', 'M'],
    name: ['Имя', 'Name'],
    noPassengers: ['Пассажиров нет', 'There are no passengers'],
    'place-kg': ['{{baggagePieces}} мест, {{baggageWeight}} кг', '{{baggagePieces}} place, {{baggageWeight}} kg'],
    pnr: ['PNR: ', 'PNR: '],
    ssr: ['SSR: ', 'SSR: '],
    ticketNumber: ['Номер билета: ', 'Ticket number: '],
};
